import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./Redux/Store/Store";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";

import { msalConfig } from "./authConfig";
import { App } from "./App";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-tabs/style/react-tabs.css";
import "./index.css";

export const msalInstance = new PublicClientApplication(msalConfig);

// Si hay varias cuentas de Microsoft guardadas (p.ej. una personal o de otra
// empresa además de la de AEDAS), se prefiere la del tenant de AEDAS: con la
// primera que saliera se podía pedir el acceso con una cuenta que el backend
// no reconoce.
const aedasTenantId = msalConfig.auth.authority?.split("/").pop();
if (!msalInstance.getActiveAccount()) {
  const accounts = msalInstance.getAllAccounts();
  const account =
    accounts.find((a) => a.tenantId === aedasTenantId) ?? accounts[0];
  if (account) {
    msalInstance.setActiveAccount(account);
  }
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App pca={msalInstance} />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
